import Popup from "reactjs-popup";
import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import { useState } from "react";
import Loader from "../../shared/Loader";
import { toast } from "react-toastify";
import {
  useActive2faViaEmail,
  useConfirmOtp2faViaEmail,
} from "../../lib/queries/queriesAndMutations";
import { useQueryClient } from "@tanstack/react-query";
import RadioBtn from "../../shared/RadioBtn";

const ActiveEmailModalBtn = ({ feildIsActive, onFactorSetiingIsActive }) => {
  const [code, setCode] = useState("");
  const { mutateAsync: activeViaEmail } = useActive2faViaEmail("");
  const { mutateAsync: confirmOtp, isPending } = useConfirmOtp2faViaEmail("");
  const [showTooltip, setShowTooltip] = useState(
    localStorage.getItem("email-tooltip") === "open"
  );
  const queryClient = useQueryClient();

  const handleSendEmail = async (active) => {
    localStorage.setItem("email-tooltip", "open");
    setShowTooltip(true);
    //console.log("handleSendSms run");
    try {
      const response = await activeViaEmail(active);
      //console.log({ response });
    } catch (error) {
      console.log({ error });
    }
  };
  const handleConfirmOtp = async ({ close, feildIsActive }) => {
    //console.log("handleSendSms run");
    try {
      const response = await confirmOtp({ otp: code, active: !feildIsActive });
      if (response.status === 200) {
        toast.success("عملیات موفق");
        queryClient.invalidateQueries({ queryKey: ["getProfile"] });
        setCode("");
        close();
      }
      //console.log({ response });
    } catch (error) {
      //console.log({ error });
    }
  };

  return (
    <Popup
      onOpen={() => handleSendEmail(!feildIsActive)}
      trigger={
        feildIsActive ? (
          <RadioBtn checked={true} onClick={() => {}} />
        ) : onFactorSetiingIsActive ? null : (
          <RadioBtn checked={false} onClick={() => {}} />
        )
      }
      onClose={() => {
        localStorage.setItem("email-tooltip", "close");
      }}
      open={showTooltip}
      modal
      nested
    >
      {(close) => (
        <div
          className="flex flex-col  bg-white rounded-[12px] p-[10px] gap-[6px]  shadow-xl w-[400px] max-h-[80vh] mx-auto "
          dir="rtl"
        >
          <p className="text-[#37393b]  text-[14px] font-semibold">
            لطفاً کد تأیید ارسال‌شده به ایمیل خود را وارد کنید تا امکان
            فعال‌سازی احراز هویت دو مرحله‌ای فراهم شود.
          </p>
          <div className="w-full flex justify-center" dir="ltr">
            <OTPInputField
              value={code}
              handleChange={setCode}
              styleObject={{ backgroundColor: "#F0F0F0" }}
              numOfInputs={6}
            />
          </div>
          <div className="flex mr-auto gap-1 mt-8">
            <button
              onClick={close}
              className="secondary-btn"
              disabled={isPending}
            >
              انصراف
            </button>
            <button
              onClick={() => handleConfirmOtp({ close, feildIsActive })}
              className="primary-btn"
              disabled={isPending}
            >
              {isPending ? (
                <div className="w-8 h-8 mx-auto">
                  <Loader />
                </div>
              ) : (
                "تایید کد"
              )}
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default ActiveEmailModalBtn;

// const ActiveEmailModalBtn = ({ feildIsActive }) => {

//   const [code, setCode] = useState("");
//   const { mutateAsync: activeViaEmail } = useActive2faViaEmail("");
//   const { mutateAsync: confirmOtp, isPending } = useConfirmOtp2faViaEmail("");

//   const handleSendEmail = async () => {
//     //console.log("handleSendSms run");
//     try {
//       const response = await activeViaEmail(true);
//       //console.log({ response });
//     } catch (error) {
//       //console.log({ error });
//     }
//   };
//   const handleConfirmOtp = async (close) => {
//     //console.log("handleSendSms run");
//     try {
//       const response = await confirmOtp({ otp: code, active: true });
//       if (response.status === 200) {
//         toast.success("رمز عبور دو مرحله ای با موفقیت فعال گردید");
//         close();
//       }
//       //console.log({ response });
//     } catch (error) {
//       //console.log({ error });
//     }
//   };

//   return (
//     <Popup
//       onOpen={() => handleSendEmail()}
//       trigger=
//           {feildIsActive ? (
//             <button className="bg-neutral-90 text-white py-1 px-3 rounded hover:bg-blue-700">
//               غیرفعالسازی
//             </button>
//           ) : (
//             <button className="bg-neutral-90 text-white py-1 px-3 rounded hover:bg-blue-700">
//               فعالسازی
//             </button>
//           )}

//       modal
//       nested
//     >
//       {(close) => (
//         <div
//           className=" bg-neutral-20 w-[400px] mb-5 rounded-v-lg p-4 flex flex-col gap-4  max-h-[80vh] mx-auto "
//           dir="rtl"
//         >
//           <p className="text-[#37393b]  text-[14px] font-semibold">
//             لطفاً کد تأیید ارسال‌شده به ایمیل خود را وارد کنید تا امکان
//             فعال‌سازی احراز هویت دو مرحله‌ای فراهم شود.
//           </p>
//           <div className="w-full flex justify-center" dir="ltr">
//             <OTPInputField
//               value={code}
//               handleChange={setCode}
//               styleObject={{ backgroundColor: "#F0F0F0" }}
//               numOfInputs={6}
//             />
//           </div>
//           <button
//             onClick={() => handleConfirmOtp(close)}
//             className="bg-dark text-white p-2 rounded-md  "
//           >
//             {isPending ? (
//               <div className="w-8 h-8 mx-auto">
//                 <Loader />
//               </div>
//             ) : (
//               "تایید کد"
//             )}
//           </button>
//         </div>
//       )}
//     </Popup>
//   );
// };

// export default ActiveEmailModalBtn;
